import React from 'react';

type ModalState = { isOpen: false; editingDate?: never } | { isOpen: true; editingDate: Date };

/**
 * A hook to manage the modal state of the ModalDateTimePicker.
 * This can also be used to manage the modal state of any modal date time picker that
 * uses the same CustomDateTimeInput and DateTimePickerModal components, like
 * GlobalDatePicker.
 */
export function useModalDateTimePicker(selectedDate: Date | number) {
  const [modalState, setModalState] = React.useState<ModalState>({ isOpen: false });

  const open = React.useCallback(
    () =>
      setModalState({
        // Freeze the current selected date while the date picker is open.
        // So the date displayed on the custom date time input will not change when the user
        // clicking a new date on the date picker.
        editingDate: new Date(selectedDate),
        isOpen: true,
      }),
    [selectedDate],
  );
  const close = React.useCallback(() => setModalState({ isOpen: false }), []);

  return {
    modalState,
    open,
    close,
  };
}
